import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getAppointments(id, params) {
        return Axios.get(`${baseURL}actor/client/${id}/appointments`, {
            params
        }).then(response => response.data.response);
    },
    getHistory(appointmentId) {
        return Axios.get(
            `${baseURL}schedule/appointment-history/${appointmentId}`
        ).then(response => response.data.response);
    }
};
